import React, { useState, useEffect } from 'react';

const PerformanceMonitor = ({ enabled = false }) => {
  const [fps, setFps] = useState(60);
  const [bubbleCount, setBubbleCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    let frameCount = 0;
    let lastTime = performance.now();

    const measureFPS = () => {
      frameCount++;
      const currentTime = performance.now();
      
      if (currentTime >= lastTime + 1000) {
        setFps(Math.round(frameCount * 1000 / (currentTime - lastTime)));
        frameCount = 0;
        lastTime = currentTime;
      }

      requestAnimationFrame(measureFPS);
    };

    const animationId = requestAnimationFrame(measureFPS);

    return () => cancelAnimationFrame(animationId);
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;

    const interval = setInterval(() => {
      const bubbles = document.querySelectorAll('[data-bubble]');
      setBubbleCount(bubbles.length);
    }, 100);

    return () => clearInterval(interval);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[200] pointer-events-none">
      <div className="bg-black/80 text-white px-3 py-2 rounded-lg text-xs font-mono">
        <div>FPS: {fps}</div>
        <div>Bubbles: {bubbleCount}</div>
      </div>
    </div>
  );
};

export default PerformanceMonitor;